<template>
  <div id="MoreArticles">
    <div id="ImgContainer" style="width: 100%">
      <img src="../assets/more_articles.png" />
    </div>
    <div
      class="titles"
      v-for="(t, index) in titles"
      @click="viewArticle(t.id, $route.params.issue, t.thisclass)"
      :key="index"
    >
      {{ t.title }}
    </div>
    <div id="BottomContainer">
      <img src="../assets/more_articles_bottom.png" />
    </div>
    <div id="LogoContainer">
      <img src="../assets/article_bottom_logo.png" />
    </div>
  </div>
</template>

<script>
import articlesStore_3 from "../store/articlesStore_3";
import articlesStore_2 from "../store/articlesStore_2";

import articlesStore_1 from "../store/articlesStore_1";
import pageStackStore from "../store/pageStackStore";
const articleList = [articlesStore_1, articlesStore_2,articlesStore_3];
export default {
  name: "MoreArticles",
  data() {
    return {
      articles: [],
      titles: [],
    };
  },
  mounted() {
    this.getRandom();
    this.setTitle();
  },
  methods: {
    getRandom() {
      while (this.articles.length < 4) {
        // console.log(this.articles, "-----1-----");

        let ran = Math.floor(
          (Math.random() - 0.0001) *
            articleList[this.$route.params.issue - 1].state.articles.length
        );
        if (
          ran != this.$route.params.id - 1 &&
          this.articles.indexOf(ran) < 0
        ) {
          this.articles.push(ran);
          console.log(this.articles);
        }
      }
    },
    // 页面跳转
    viewArticle: function (id, issue, thisclass) {
      // console.log(id,'------------------>');
      pageStackStore.commit("pushPageStack", this.$route.path);
      this.$router.replace({
        name: "Article",
        params: { id, issue, class: thisclass },
      });
    },
    setTitle() {
      for (let i = 0; i < this.articles.length; i++) {
        // console.log(this.articles,'---------1--------------');
        // if (this.$route.params.issue == 3) {
        //   let issue = articleList[this.$route.params.issue - 1];
        // } else {
        //   let issue = articleList[this.$route.params.issue - 2];
        // }
        let issue = articleList[this.$route.params.issue - 1];
        // console.log(issue,'-----------2-----');
        // console.log(this.$route.params.issue ,'-----------3-----');
        let title = issue.state.articles[this.articles[i]].title;
        let id = this.articles[i] + 1;
        let thisclass = 1;
        for (let j = 0; j < issue.state.classes.length; j++) {
          if (
            issue.state["class" + (j + 1)].banner.indexOf(this.articles[i]) >= 0
          ) {
            thisclass = j + 1;
            break;
          }
          if (
            issue.state["class" + (j + 1)].marquees.indexOf(this.articles[i]) >=
            0
          ) {
            thisclass = j + 1;
            break;
          }
          if (
            issue.state["class" + (j + 1)].list.indexOf(this.articles[i]) >= 0
          ) {
            thisclass = j + 1;
            break;
          }
        }
        // console.log(tr);
        this.titles.push({
          title,
          id,
          thisclass,
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
#MoreArticles {
  padding-bottom: 1.2rem;
  line-height: 0.88rem;
  font-size: 0.35rem;

  #ImgContainer {
    width: 9.45rem;

    img {
      width: 100%;
    }
  }

  .titles {
    width: 100%;
    text-align: center;
    color: #004edc;
    line-height: 0.45rem;
    margin-top: 0.5rem;
  }

  #BottomContainer {
    width: 100%;

    img {
      width: 100%;
    }
  }

  #LogoContainer {
    width: 100%;
    margin-top: 1.4rem;
    display: flex;
    justify-content: center;

    img {
      width: 4.11rem;
      height: 0.75rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MoreArticles.vue